// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./filespace-card.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilespaceCard-module__Container__R7QGx {
    display: flex;
    flex-direction: column;
    gap: var(--ds-s);
    min-width: var(--ds-36x);
    max-width: var(--ds-36x);
    min-height: var(--ds-43x);
    max-height: var(--ds-43x);
    padding: var(--ds-sm);
    border-radius: var(--ds-border-radius-m);
    outline: none;
    cursor: pointer;
}

.FilespaceCard-module__Container__R7QGx:hover {
    background: var(--ds-interaction-hover);
}

.FilespaceCard-module__Container__R7QGx:active,
.FilespaceCard-module__Active__RqRC6 {
    background: var(--ds-interaction-select);
}

.FilespaceCard-module__Container__R7QGx:focus-visible {
    background: var(--ds-interaction-select);
    outline: var(--ds-border-width-focus) solid
        var(--widget-filespace-card-outline-focus-color);
}

.FilespaceCard-module__Details__jpyWh {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: var(--ds-s);
}

.FilespaceCard-module__DetailsStatus__RT6xj {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `FilespaceCard-module__Container__R7QGx`,
	"Active": `FilespaceCard-module__Active__RqRC6`,
	"Details": `FilespaceCard-module__Details__jpyWh`,
	"DetailsStatus": `FilespaceCard-module__DetailsStatus__RT6xj`
};
export default ___CSS_LOADER_EXPORT___;
